var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:("preloader preloader-" + (_vm.firstVisit ? 'first-visit' : '') + " preloader-" + (_vm.loaded ? 'hide' : ''))},[_c('img',{staticClass:"preloader-progress",attrs:{"src":"/static/preloader.gif"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f003c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader.vue
// module id = 260
// module chunks = 0